import { render, staticRenderFns } from "./MoneyCircleIcon.vue?vue&type=template&id=1ba6a110&scoped=true"
import script from "./MoneyCircleIcon.vue?vue&type=script&lang=js"
export * from "./MoneyCircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba6a110",
  null
  
)

export default component.exports